blue.ready('checklist', '.checklist:not(.checklist--nocheck)', checklist => {
	const list = checklist.querySelector('.checklist-list') //ul
	let storage = JSON.parse(window.localStorage.getItem(`checklist-${checklist.getAttribute('id')}`)) || [] //local storage or empty array
	let items = [...list.querySelectorAll('.checklist-item')] //[li,li,li]
	let labels = [...list.querySelectorAll('.checklist-label')] //[label,label]
	let links = [...list.querySelectorAll('a.checklist-text')] //[a,a]
	let timeout = 250 // animation duration
	let checked // array of checked items used in reorder
	let unchecked // array of unchecked items used in reorder
	let greatest // holds the element with the next largest order to the current element

	// refresh element arrays (they may have changed)
	const requery = () => {
		items = [...list.querySelectorAll('.checklist-item')]
		labels = [...list.querySelectorAll('.checklist-label')]
		links = [...list.querySelectorAll('a.checklist-text')]
	}
	
	const generate = () => {
		let checks = []
		let unchecks = []
		storage.forEach(item => {
			let li = document.createElement('LI')
			let input = document.createElement('INPUT')
			let label = document.createElement('LABEL')
			let text = item.link ? document.createElement('A') : document.createElement('SPAN')

			li.classList.add('checklist-item')
			input.classList.add('checklist-input')
			input.setAttribute('id', item.id)
			input.setAttribute('type', 'checkbox')
			label.classList.add('checklist-label')
			label.setAttribute('for', item.id)
			text.classList.add('checklist-text')
			text.innerText = item.text
			if (item.checked) {
				li.classList.add('is-checked')
				input.setAttribute('checked', 'checked')
			}
			if (item.link) {
				text.setAttribute('href', item.link)
			}

			label.insertAdjacentElement('afterbegin', text)
			li.insertAdjacentElement('afterbegin', label)
			li.insertAdjacentElement('afterbegin', input)
			
			li.__order = item.order
			li.__pos = {}

			if (item.checked) {
				checks.push(li)
			}
			else {
				unchecks.push(li)
			}
		})

		checks.sort((a, b) => {
			return a.__order > b.__order
		})
		unchecks.sort((a, b) => {
			return a.__order > b.__order
		})

		list.innerHTML = ''
		checks.forEach(elem => {
			list.insertAdjacentElement('beforeend', elem)
		})
		unchecks.forEach(elem => {
			list.insertAdjacentElement('beforeend', elem)
		})
		
		requery()
	}

	const store = (_this) => {
		if (_this) {
			for (let item of storage) {
				if (item.id == _this.querySelector('.checklist-input').getAttribute('id')) {
					let data = {
						checked: _this.classList.contains('is-checked'),
						order: _this.__order,
						id: _this.querySelector('.checklist-input').getAttribute('id'),
						text: _this.querySelector('.checklist-text').innerText,
						link: _this.querySelector('.checklist-text').getAttribute('href')
					}
					storage[storage.indexOf(item)] = data
					break
				}
			}
		}
		else {
			items.forEach(item => {
				storage.push({
					checked: item.classList.contains('is-checked'),
					order: item.__order,
					id: item.querySelector('.checklist-input').getAttribute('id'),
					text: item.querySelector('.checklist-text').innerText,
					link: item.querySelector('.checklist-text').getAttribute('href')
				})
			})
		}
		window.localStorage.setItem(`checklist-${checklist.getAttribute('id')}`, JSON.stringify(storage))
	}

	const reorder = function(e) {
		let _this = this.closest('.checklist-item')
		requery()
		if (_this.classList.contains('is-checked')) {
			_this.classList.remove('is-checked')
			unchecked = items.filter(item => (item != _this && !item.classList.contains('is-checked')))

			if (unchecked.length) {
				for (let uncheck of unchecked) {
					if (uncheck.__order > _this.__order) {
						greatest = uncheck
						break
					}
				}
				if (greatest) {
					flip(greatest, 'beforebegin', _this)
				}
				else {
					flip(unchecked[unchecked.length - 1], 'afterend', _this)
				}
			}
			else {
				flip(list, 'beforeend', _this)
			}
		}
		else {
			_this.classList.add('is-checked')
			checked = items.filter(item => (item != _this && item.classList.contains('is-checked')))

			if (checked.length) {
				for (let check of checked) {
					if (check.__order > _this.__order) {
						greatest = check
						break
					}
				}
				if (greatest) {
					flip(greatest, 'beforebegin', _this)
				}
				else {
					flip(checked[checked.length - 1], 'afterend', _this)
				}
			}
			else {
				flip(list, 'afterbegin', _this)
			}
		}
		store(_this)
		greatest = undefined
	}

	const flip = (ref, pos, _this) => {
		requery()
		items.forEach(item => {
			let rect = item.getBoundingClientRect()
			item.__pos.startX = rect.left
			item.__pos.startY = rect.top
		})

		ref.insertAdjacentElement(pos, _this)

		items.forEach(item => {
			let rect = item.getBoundingClientRect()
			item.__pos.endX = rect.left
			item.__pos.endY = rect.top
		})

		items.forEach(item => {
			item.style.transform = `translate(${item.__pos.startX - item.__pos.endX}px, ${item.__pos.startY - item.__pos.endY}px)`
			setTimeout(() => {
				item.style.transition = `transform ${timeout}ms ease`
			})
			setTimeout(() => {
				item.style.transform = ''
			})
			setTimeout(() => {
				item.style.transition = ''
			}, timeout)
		})
	};

  const listHasBeenUpdated = function() {
    if (storage.length != labels.length) return true;

    for (let i = 0; i < labels.length; i++) {
      if (storage[i].text != labels[i].innerText) {
        return true;
      }
    }

    return false;
  };

	if (storage.length && !listHasBeenUpdated()) {
		generate()
	}
	else {
		items.forEach(item => item.__order = items.indexOf(item));
		items.forEach(item => item.__pos = {});
		storage = []; // clear storage
		store()
	}

	links.forEach(link => link.addEventListener('click', e => e.stopPropagation()))
	labels.forEach(label => label.addEventListener('click', reorder))
})